import * as yup from 'yup'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import Calculate from '@mui/icons-material/Calculate';
import InputNumber from '../../../../components/inputs/yup/materialui/inputNumber';
import { Folder, AttachMoney, MoneyOff } from '@mui/icons-material';
import { useEffect } from 'react';
import { CalculateRecaudacionEM } from '../models/calculateRecaudacionEM';
import { MutuosARecaudar } from '../models/mutuosARecaudar';

interface IProps {
    onCalculate: () => CalculateRecaudacionEM
    onSubmit: () => void,
    isFormReseting: boolean,
    mutuosSeleccionados: MutuosARecaudar[]
}

export const FormularioCalculoRecaudacionEndoso = ({onCalculate, onSubmit, isFormReseting, mutuosSeleccionados} : IProps) => {

    const validationSchema: yup.ObjectSchema<CalculateRecaudacionEM> = yup.object().shape({
        totalMontoNominal: yup.number().nullable().optional(),
        totalMontoOperacion: yup.number().nullable().optional(),
        totalMontoRecaudar: yup.number().nullable().optional()
    })

    const {
        register,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
    } = useForm<CalculateRecaudacionEM>({ resolver: yupResolver(validationSchema) })

    const calcular = () => {
        const result : CalculateRecaudacionEM = onCalculate();
        setValue("totalMontoNominal", result.totalMontoNominal);
        setValue("totalMontoOperacion", result.totalMontoOperacion);
        setValue("totalMontoRecaudar", result.totalMontoRecaudar);
    }

    useEffect(() => {
        if (isFormReseting){
            reset();
        }
    }, [isFormReseting])

    return(
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputNumber 
                        label="Total monto nominal"
                        name="totalMontoNominal"
                        prefix='UF'
                        control={control}
                        error={errors.totalMontoNominal}
                        minValue={0}
                        maxValue={9999999999}
                        decimales={4}
                        presicion={14}
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputNumber 
                        label="Total valor operación"
                        name="totalMontoOperacion"
                        prefix='UF'
                        control={control}
                        error={errors.totalMontoOperacion}
                        minValue={0}
                        maxValue={9999999999}
                        decimales={4}
                        presicion={14}
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputNumber 
                        label="Total monto a recaudar"
                        name="totalMontoRecaudar"
                        control={control}
                        error={errors.totalMontoRecaudar}
                        prefix='UF'
                        minValue={0}
                        maxValue={9999999999}
                        decimales={4}
                        presicion={14}
                        disabled
                    />
                </Grid2>
            </Grid2>
            <Grid2 container size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "10px" }} spacing={3}>
                <MButton variant="contained" color="primary" startIcon={<Calculate />} onClick={calcular} disabled={mutuosSeleccionados.length == 0}>
                    Recalcular
                </MButton>
                <MButton type="submit" variant="contained" color="primary" startIcon={<AttachMoney />} disabled={mutuosSeleccionados.length == 0}>
                    Recaudar
                </MButton>
            </Grid2>
        </form>
    );
}